import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { faqs } from '../data/content';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-white px-5 py-20 sm:px-8" data-id="element-69" data-mp="1gd7h4a4s9d6j">
      <div className="mx-auto w-full max-w-2xl" data-id="element-70" data-mp="1gaurdass9yix">
        <Reveal data-id="element-71" data-mp="2dzemhm8wv9jy">
          <h2 className="text-center font-display text-3xl font-extrabold tracking-tight text-navy sm:text-4xl" data-id="element-72" data-mp="2dzxti7x0wdj7">
            Frequently Asked <span className="text-cheer" data-id="element-73" data-mp="28ziivo44lk4x">Questions</span>
          </h2>
        </Reveal>

        <Reveal delay={0.06} data-id="element-74" data-mp="244cxqrijs9hw">
          <div className="mt-12 overflow-hidden rounded-card border border-navy/10" data-id="element-75" data-mp="1z3fgch5d3jhg">
            {faqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return <div key={faq.question} className={index > 0 ? 'border-t border-navy/10' : ''} data-id="element-76" data-mp="noa00acb5mfd" data-mpi={index}>
                  <h3 data-id="element-77" data-mp="pih8c5osb5t5">
                    <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 bg-white px-5 py-5 text-left transition-colors duration-150 ease-out hover:bg-blush focus:outline-none focus-visible:ring-2 focus-visible:ring-cheer/40" data-id="element-78" data-mp="pg3ge5pei9pt">
                      <span className="text-sm font-bold text-navy" data-id="element-79" data-mp="bietksbrwsi4">{faq.question}</span>
                      {isOpen ? <MinusIcon className="h-4 w-4 shrink-0 text-cheer" aria-hidden="true" data-id="element-80" data-mp="3szziwkvxyqx9" /> : <PlusIcon className="h-4 w-4 shrink-0 text-cheer" aria-hidden="true" data-id="element-81" data-mp="3jz9ptoy2fen8" />}
                    </button>
                  </h3>
                  <AnimatePresence initial={false} data-id="element-82" data-mp="1pq4j8onl8iyi">
                    {isOpen && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.22,
                  ease: [0.23, 1, 0.32, 1]
                }} className="overflow-hidden bg-blush" data-id="element-83" data-mp="1pob9h0hohima">
                        <p className="px-5 pb-5 pt-4 text-sm leading-relaxed text-navy/75" data-id="element-84" data-mp="28hf8z2hkupot">
                          {faq.answer}
                        </p>
                      </motion.div>}
                  </AnimatePresence>
                </div>;
          })}
          </div>
        </Reveal>
      </div>
    </section>;
}